// Full-document render of the Oscar account-registration view: PageSkeleton
// (the React document shell) wrapping RegistrationBody.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { RegistrationBody } from "../components/RegistrationBody";

export const Template = (
    props: templates.RegistrationDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <RegistrationBody {...props} />
        </PageSkeleton>
    );
};
